import Routes from './routes/index';
const App = () => <Routes/>
export default App